import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navbar, Dropdown, Popover, OverlayTrigger } from 'react-bootstrap';
import history from '../../../history';
import CyberSecurity from '../../../apis/cyberSecurityData';
import { addNewFeed, addFeedComment } from '../../../actions/Dashboard/boardsActions';
import { logoutUser, updateProfile } from '../../../actions/userActions';
import { toggleDarkMode } from '../../../actions/darkModeActions';
import { setBreachesListPage } from '../../../actions/Dashboard/breachesSectionActions';
import { setThreatsListPage } from '../../../actions/Dashboard/threatsSectionActions';
import { setMainDashboardCategory } from '../../../actions/Dashboard/mainDashboardActions';
import { setNewsPageView } from '../../../actions/Dashboard/newsSectionActions';

import { Scrollbars } from 'react-custom-scrollbars';

//icons
import { Icon } from '@iconify/react';
import moonFull from '@iconify/icons-wi/moon-full';
import moonAltThirdQuarter from '@iconify/icons-wi/moon-alt-third-quarter';
import pinHelp from '@iconify/icons-zmdi/pin-help';
import feedbackIcon from '@iconify-icons/dashicons/feedback';
import loginIcon from '@iconify/icons-mdi/login';
import rssIcon from '@iconify/icons-fa-solid/rss';
import baselineDashboard from '@iconify/icons-ic/baseline-dashboard';
import chatRightFill from '@iconify/icons-bi/chat-right-fill';
import bugOutlined from '@iconify-icons/ant-design/bug-outlined';
import personBoundingBox from '@iconify-icons/bi/person-bounding-box';
import thunderboltOutlined from '@iconify/icons-ant-design/thunderbolt-outlined';
import networkAlt from '@iconify/icons-iconoir/network-alt';
import baselineManageAccounts from '@iconify/icons-ic/baseline-manage-accounts';
import eyeScanBold from '@iconify/icons-solar/eye-scan-bold';

//imported comps
import FeedbackContent from './sections/MainDashboard/FeedbackContent';
import LoginModal from '../../Modals/LoginModal/LoginModal';
import RequestAccessModal from '../../Modals/RequestAccessModal/RequestAccessModal';
import FeatureLockedModal from './sections/newsSection/filters/FeatureLockedModal';
import CrowdStrikeDomainSettings from './sections/DetectionRules/DetectionsDashboard/CrowdStrikeDomainSettings';


const DashboardNavigation = (props) => {
    // if (window.location?.ancestorOrigins?.length > 0) {
    //     console.log({
    //         containsTest: window.location.ancestorOrigins.contains('https://trukno-iframe.herokuapp.com'),
    //         testValue: window.location.ancestorOrigins
    //     });
    // } else console.log('No ancestorOrigins');

    //redux store state
    const darkMode = useSelector(state => state.darkMode);
    const currentUser = useSelector(state => state.currentUser);
    const currentView = useSelector(state => state.dashboard_currentSection);
    const category = useSelector(state => state.dashboard_Main.category);
    const socket = useSelector(state => state.dashboard_socket);
    const activeBoard = useSelector(state => state.dashboard_Boards.activeBoard);
    const enterprise = useSelector(state => state.enterprise);
    const isTesting = useSelector(state => state.isTesting);

    const dispatch = useDispatch();
    //comp local state
    const [showNotification, setShowNotification] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [loginModalAction, setLoginModalAction] = useState('signup');
    const [showRequestAccessModal, setShowRequestAccessModal] = useState(false);
    const [showFeatureLockedModal, setShowFeatureLockedModal] = useState(false);

    useEffect(() => {
        if (socket) {

            socket.on('newMessageAdded', (data) => {
                handleRecivedEvent(data);
                if (activeBoard._id === data.board._id) dispatch(addNewFeed(data.message));

            });

            socket.on('newItemAdded', (data) => {
                handleRecivedEvent(data);
                if (activeBoard._id === data.board._id) dispatch(addNewFeed(data.item));
            });

            socket.on('newCommentAdded', (data) => {
                handleRecivedEvent(data);
                if (activeBoard._id === data.board._id) dispatch(addFeedComment(data.comment));
            });
        }
    }, [socket, activeBoard]);

    const handleRecivedEvent = (data) => {
        const { item, message, comment, board } = data;

        const notificationMessage = `New message for board ${board.name}`;

        if (history.location.pathname === '/dashboard/boards') {
            if (activeBoard._id !== board._id) {
                //user on boards page and not showing the board for the recevied event
                setNotificationMessage(notificationMessage);
                setShowNotification(true);
            } else {
                //user on boards page and showing the board for the recevied event
                //so here we need to update the boardFeed state based on the comming event
                setNotificationMessage('');
                setShowNotification(false);
                // if (item && activeBoard._id === board._id) dispatch(addNewFeed(item));
                // else if (message && activeBoard._id === board._id) dispatch(addNewFeed(message));
                // else if (comment && activeBoard._id === board._id) dispatch(addFeedComment(comment));
            }
        } else {
            //here user is not on the boards page
            setNotificationMessage(notificationMessage);
            setShowNotification(true);
        }
    };

    const onItemClick = (section) => {
        if (['userDashboard', 'main', 'threats', 'malware', 'actors', 'cves', 'tenable', 'assets', 'ciso', 'search'].includes(section)) {
            if (!currentUser._id) return setShowRequestAccessModal(true);
            if (!enterprise._id) return setShowRequestAccessModal(true);
        }
        switch (section) {
            case 'userDashboard':
                dispatch(setBreachesListPage(1));
                dispatch(setThreatsListPage(1));
                history.push(`/dashboard/user/${currentUser._id}`);
                break;
            case 'ciso':
                // if (isTesting && ['admin', 'owner'].includes(currentUser.userRole)) {
                //     window.location.href = `${process.env.REACT_APP_TRUKNO_NEXT_URL}/dashboard/ciso`;
                //     break;
                // }
                dispatch(setBreachesListPage(1));
                dispatch(setThreatsListPage(1));
                history.push(`/dashboard/ciso`);
                break;
            case 'search':
                dispatch(setBreachesListPage(1));
                dispatch(setThreatsListPage(1));
                history.push(`/dashboard/search`);
                break;
            case 'detections':
                dispatch(setBreachesListPage(1));
                dispatch(setThreatsListPage(1));
                history.push(`/dashboard/detections`);
                break;
            case 'scanResults':
                dispatch(setBreachesListPage(1));
                dispatch(setThreatsListPage(1));
                history.push(`/dashboard/scan-results`);
                break;
            case 'main':
                dispatch(setBreachesListPage(1));
                dispatch(setThreatsListPage(1));
                if (category !== 'breaches') dispatch(setMainDashboardCategory('breaches'));
                if (history.location.pathname !== `/dashboard/main`) history.push('/dashboard/main');
                break;
            case 'threats':
                dispatch(setBreachesListPage(1));
                dispatch(setThreatsListPage(1));
                if (category !== 'threats') dispatch(setMainDashboardCategory('threats'));
                if (history.location.pathname !== `/dashboard/main`) history.push('/dashboard/main');
                break;
            case 'malware':
                dispatch(setBreachesListPage(1));
                dispatch(setThreatsListPage(1));
                if (category !== 'malware') dispatch(setMainDashboardCategory('malware'));
                if (history.location.pathname !== `/dashboard/main`) history.push('/dashboard/main');
                break;
            case 'actors':
                dispatch(setBreachesListPage(1));
                dispatch(setThreatsListPage(1));
                if (category !== 'actors') dispatch(setMainDashboardCategory('actors'));
                if (history.location.pathname !== `/dashboard/main`) history.push('/dashboard/main');
                break;
            case 'cves':
                dispatch(setBreachesListPage(1));
                dispatch(setThreatsListPage(1));
                if (category !== 'cves') dispatch(setMainDashboardCategory('cves'));
                if (history.location.pathname !== `/dashboard/main`) history.push('/dashboard/main');
                break;
            case 'tenable':
                dispatch(setBreachesListPage(1));
                dispatch(setThreatsListPage(1));
                if (history.location.pathname !== `/dashboard/cves/tenable`) history.push('/dashboard/cves/tenable');
                break;
            case 'assets':
                dispatch(setBreachesListPage(1));
                dispatch(setThreatsListPage(1));
                if (history.location.pathname !== `/dashboard/assets`) {
                    if (showTenable()) {
                        history.push('/dashboard/assets');
                        break;
                    }
                    if (showQualys()) {
                        history.push('/dashboard/qualys/assets');
                        break;
                    }
                }
                break;
            case 'boards':
                if (!currentUser._id) {
                    setShowFeatureLockedModal(true);
                    break;
                }
                dispatch(setBreachesListPage(1));
                dispatch(setThreatsListPage(1));
                if (history.location.pathname !== `/dashboard/myboard`) history.push('/dashboard/myboard');
                break;
            default:
                //reseting page number for Breaches and Threats Section
                dispatch(setBreachesListPage(1));
                dispatch(setThreatsListPage(1));
                //reseting the view for news page
                if (section !== 'news') dispatch(setNewsPageView('main'));
                history.push(section);
        }
    };

    const renderDarkMode = () => {
        if (darkMode === true) return <Icon icon={moonAltThirdQuarter} style={{ fontSize: '20px' }} hFlip={true} />;
        if (darkMode === false) return <Icon icon={moonFull} style={{ fontSize: '20px' }} hFlip={true} />;
    };

    const renderLogo = () => {
        if (darkMode === true) return <img src={require('../../../images/TruKno-Logo-New.svg').default} alt="logo" className="img-fluid" style={{ width: '32px' }} />;
        if (darkMode === false) return <img src={require('../../../images/TruKno-Logo-New.svg').default} alt="logo" className="img-fluid" style={{ width: '32px' }} />;
    };

    // const onHelpClick = async () => {
    //     // setStartTour(true)
    //     const response = await CyberSecurity.post('/users/demo', { page: 'mainDashboard', state: true }, {
    //         headers: {
    //             Authorization: 'Bearer ' + accessToken
    //         }
    //     })
    //     dispatch(updateProfile(response.data));
    // }

    const FeedbackPopover = (
        <Popover id={`popover-basic-feedback`}>
            <Popover.Content as="div">
                <FeedbackContent />
            </Popover.Content>
        </Popover>
    );

    const renderImage = () => {
        return currentUser.image === '/static/media/default-profile-picture1.96f6bf15.png'
            ? require('../../../images/default-profile-picture1.png')
            : currentUser.image;
    };

    const showBoards = () => {
        if (['admin', 'owner'].includes(currentUser.userRole)) return true;
        if (currentUser._id === '5f96e620599f1b0017cc4ce4') return true;
        return false;
    };

    // const onLogoClick = () => {
    //     // if (currentUser._id) {
    //     //     if (category !== 'breaches') dispatch(setMainDashboardCategory('breaches'));
    //     //     if (history.location.pathname !== '/dashboard/main') history.push('/dashboard/main');
    //     //     return;
    //     // }
    //     history.push(process.env.REACT_APP_TRUKNO_BASE_URL);
    // };

    const checkActiveSection = (section) => {
        const active = '';
        const pathname = history.location.pathname;

        if (section === 'search') {
            if (pathname.includes('search')) return 'active';
            if (pathname === `/dashboard/main` && category === 'breaches') return 'active';
        }

        if (section === 'breaches') {
            if (pathname.includes('breach')) return 'active';
            if (pathname === `/dashboard/main` && category === 'breaches') return 'active';
        }

        if (section === 'ciso') {
            if (pathname.includes('breach')) return 'active';
            if (pathname === `/dashboard/ciso` && category === 'breaches') return 'active';
        }

        if (section === 'threats') {
            if (pathname.includes('threat')) return 'active';
            if (pathname === `/dashboard/main` && category === 'threats') return 'active';
        }

        if (section === 'malware') {
            if (pathname.includes('malware')) return 'active';
            if (pathname === `/dashboard/main` && category === 'malware') return 'active';
        }

        if (section === 'actors') {
            if (pathname.includes('actor')) return 'active';
            if (pathname === `/dashboard/main` && category === 'actors') return 'active';
        }

        if (section === 'cves') {
            if (pathname === `/dashboard/main` && category === 'cves') return 'active';
            if (pathname === `/dashboard/cves/tenable`) return 'active';
        }

        if (section === 'assets') {
            if (pathname === `/dashboard/assets` || pathname === `/dashboard/qualys/assets`) return 'active';
        }

        if (section === 'tenable') {
            if (pathname === `/dashboard/cves/tenable`) return 'active';
        }

        return active;
    };

    const showTenable = () => {
        if (!enterprise._id) return false;
        if (!currentUser._id) return false;
        if (enterprise.hasTenableToken !== true) return false;
        if (enterprise.tenableAccess?.includes(currentUser._id)) return true;
        if (enterprise.owner === currentUser._id) return true;
        return false;
    };

    const showQualys = () => {
        if (!enterprise._id) return false;
        if (!currentUser._id) return false;
        if (enterprise.qualysAccess?.includes(currentUser._id)) return true;
        return false;
    };

    const onCreateFreeAccountClick = () => {
        setShowFeatureLockedModal(false);
        setLoginModalAction('signup');
        setShowLoginModal(true);
    };

    const isIframe = () => {
        if (window.location?.ancestorOrigins?.length > 0 && window.location?.ancestorOrigins?.contains('https://trukno-iframe.herokuapp.com')) {
            return true;
        }
        return false;
    };

    return (
        <div className="d-flex dashboard-sidebar" style={{ color: currentView === 'All' ? '#1dc4e9' : '#a9b7d0' }}>
            <div>
                <Navbar.Brand style={{ cursor: 'pointer' }} className="d-block" href={process.env.REACT_APP_TRUKNO_BASE_URL}>
                    <div className="mainDashboard_step01">
                        {renderLogo()}
                    </div>
                </Navbar.Brand>

                <div className="d-none">
                    <Dropdown>
                        <Dropdown.Toggle variant="link" id="dropdown-basic" className="text-center">
                            <div className="user-avatar"><img src={currentUser.image} alt="logo" className="img-fluid" /></div>
                        </Dropdown.Toggle>
                    </Dropdown>
                </div>

                <div className="d-flex align-items-baseline flex-column mt-4 pt-xl-3 w-100">

                    <div className={`dashboard-sidebar-menu-item text-center pointer ${history.location.pathname.includes(`/dashboard/ciso`) ? "active" : ""}`} onClick={() => onItemClick('ciso')}>
                        <div>
                            <Icon icon={baselineDashboard} style={{ fontSize: '24px' }} hFlip={true} />
                            <p>CISO</p>
                        </div>
                    </div>

                    {/* {isTesting && <div className={`dashboard-sidebar-menu-item text-center pointer`}>
                        <a href={`${process.env.REACT_APP_TRUKNO_NEXT_URL}/dashboard/ciso`}>
                            <Icon icon={baselineDashboard} style={{ fontSize: '24px' }} hFlip={true} />
                            <p>CISO</p>
                        </a>
                    </div>} */}

                    {!isIframe() &&
                        <div className={`dashboard-sidebar-menu-item text-center pointer ${history.location.pathname.includes(`/dashboard/search`) ? "active" : ""}`} onClick={() => onItemClick('search')}>
                            <span className="material-icons">search</span>
                            <p>Search</p>
                        </div>}

                    {!isIframe() &&
                        <div className={`dashboard-sidebar-menu-item text-center pointer ${history.location.pathname.includes(`/dashboard/detections`) ? "active" : ""}`} onClick={() => onItemClick('detections')}>
                            <Icon icon={eyeScanBold} style={{ fontSize: '22px' }} />
                            <p>Detections</p>
                        </div>}

                    {!isIframe() && isTesting &&
                        <div className={`dashboard-sidebar-menu-item text-center pointer ${history.location.pathname.includes(`/dashboard/scan-results`) ? "active" : ""}`} onClick={() => onItemClick('scanResults')}>
                            <Icon icon="material-symbols-light:scan-outline" fontSize={26} />
                            <p>Scan Results</p>
                        </div>}

                    {!isIframe() && <div className={`dashboard-sidebar-menu-item text-center pointer ${checkActiveSection('breaches')}`} onClick={() => onItemClick('main')}>
                        <span className="">
                            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    fill={checkActiveSection('breaches') === 'active' ? 'white' : "inherit"}
                                    fillRule="evenodd" clipRule="evenodd" d="M10.4023 2.94403C6.72009 4.79992 7.78185 4.48501 8.61497 5.40355C9.02212 5.85282 9.22999 6.51446 9.09618 6.93759C8.90509 7.54205 9.41167 7.93128 11.7907 9.0087L14.7201 10.3361L13.8301 11.2816C13.3408 11.8015 12.9401 12.4113 12.9401 12.6363C12.9401 12.8613 14.1657 13.8252 15.6633 14.7781C17.7519 16.1071 18.2401 16.3199 18.7302 15.9764C19.7099 14.4542 20.8355 10.6318 21.0225 8.19226C21.2165 5.66494 21.1682 5.43541 20.4411 5.43541C20.0053 5.43541 18.0931 4.66063 16.192 3.7135C14.2909 2.76678 12.6435 1.96055 12.531 1.92216C12.4184 1.88377 11.4605 2.34365 10.4023 2.94403ZM5.76009 4.79992L3.84009 5.60327L4.04673 8.27639C4.44283 13.3964 6.75355 17.8772 10.4457 20.6834L12.506 22.2493L14.3052 20.9599C16.3921 19.4639 17.2801 18.2399 17.2801 17.2799C12.6456 14.2551 10.7526 13.05 10.7526 12.8025C10.7526 12.6388 11.1208 12.1723 11.571 11.766C12.0211 11.3596 12.3893 10.8989 12.3893 10.7429C12.3893 10.5868 11.183 9.94725 9.70913 9.32196C7.19995 8.25761 7.04404 8.11507 7.26951 7.09156C7.63533 5.42806 6.24009 5.27992 5.76009 4.79992Z" />
                            </svg>
                        </span>
                        <p>Breaches</p>
                    </div>}

                    {!isIframe() && <div className={`dashboard-sidebar-menu-item text-center pointer ${checkActiveSection('threats')}`} onClick={() => onItemClick('threats')}>
                        <span className={`material-icons ${history.location.pathname === `/dashboard/main` && category === 'threats' ? 'active' : ''}`}>warning</span>
                        <p>TTPs</p>
                    </div>}

                    {!isIframe() && <div className={`dashboard-sidebar-menu-item text-center pointer ${checkActiveSection('malware')}`} onClick={() => onItemClick('malware')}>
                        <Icon icon={bugOutlined} style={{ fontSize: '22px' }} hFlip={false} />
                        <p>Malware</p>
                    </div>}

                    {!isIframe() && <div className={`dashboard-sidebar-menu-item text-center pointer ${checkActiveSection('actors')}`} onClick={() => onItemClick('actors')}>
                        <Icon icon={personBoundingBox} style={{ fontSize: '22px' }} hFlip={false} />
                        <p>Actors</p>
                    </div>}

                    {!isIframe() && <div className={`dashboard-sidebar-menu-item text-center pointer ${checkActiveSection('cves')}`} onClick={() => onItemClick('cves')}>
                        <Icon icon={thunderboltOutlined} style={{ fontSize: '26px' }} hFlip={false} />
                        <p>Vulnerability</p>
                    </div>}

                    {/* {!isIframe() && (showTenable() || showQualys()) && process.env.REACT_APP_TRUKNO_BASE_URL !== 'https://www.trukno.com' && <div className={`dashboard-sidebar-menu-item text-center pointer ${checkActiveSection('assets')}`} onClick={() => onItemClick('assets')}>
                        <Icon icon={networkAlt} style={{ fontSize: '26px' }} hFlip={false} />
                        <p>Assets</p>
                    </div>} */}

                    <div className={`dashboard-sidebar-menu-item text-center pointer ${history.location.pathname === `/dashboard/news` ? "active" : ""}`} onClick={() => onItemClick('/dashboard/news')}>
                        <Icon icon={rssIcon} style={{ fontSize: '24px' }} />
                        <p>News</p>
                    </div>

                    <div className={`dashboard-sidebar-menu-item text-center pointer ${history.location.pathname === `/dashboard/myboard` ? "active" : ""}`} onClick={() => onItemClick('boards')}>
                        <Icon icon={chatRightFill} style={{ fontSize: '22px' }} hFlip={false} />
                        <p>My board</p>
                    </div>

                </div>
            </div>

            <div className="dashboard-menu-bottom-toggle">
                <div className="dark-mode-toggle text-center pointer" onClick={() => dispatch(toggleDarkMode())}>
                    <span className="dark-mode-toggle__icon">{renderDarkMode()}</span>
                    <p className="mb-0 mb-lg-3">Theme</p>
                </div>
                {/* {history.location.pathname === `/dashboard/main` && <div className="dark-mode-toggle text-center pointer" onClick={onHelpClick}>
                        <Icon icon={pinHelp} width={20} />
                        <p>Help</p>
                    </div>} */}

                <OverlayTrigger trigger="click" placement="top" overlay={FeedbackPopover} rootClose>
                    <div className="dark-mode-toggle text-center pointer" >
                        <Icon icon={feedbackIcon} width={20} />
                        <p className="mb-1">Feedback</p>
                    </div>
                </OverlayTrigger>

                {currentUser._id
                    ? <Dropdown>
                        <Dropdown.Toggle variant="link" id="dropdown-basic" className="d-none d-lg-block text-center">
                            <div className="user-avatar"><img src={renderImage()} alt="logo" className="img-fluid" /></div>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => history.push('/#demo')}>Contact Us</Dropdown.Item>
                            <Dropdown.Item onClick={() => history.push('/resources')}>Resources</Dropdown.Item>
                            <Dropdown.Item onClick={() => history.push('/pricing')}>Pricing</Dropdown.Item>
                            <Dropdown.Item onClick={() => history.push('/')}>About</Dropdown.Item>
                            <Dropdown.Item onClick={() => history.push('/profile')}>My Account</Dropdown.Item>
                            <Dropdown.Item onClick={() => dispatch(logoutUser())}>Log out</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    : <div className="dark-mode-toggle text-center pointer" onClick={() => { setLoginModalAction('login'); setShowLoginModal(true); }}>
                        <Icon icon={loginIcon} width={25} />
                        <p>Login</p>
                    </div>
                }

            </div>

            {
                showNotification && <div className="notification-panel">
                    <div className="d-flex">
                        <span className="material-icons ml-auto pointer" onClick={() => {
                            setShowNotification(false);
                            setNotificationMessage('');
                        }}>clear</span>
                    </div>
                    <div className="p-2">
                        <p className="text-light">{notificationMessage}</p>
                    </div>
                </div>
            }
            <LoginModal showLoginModal={showLoginModal} setShowLoginModal={setShowLoginModal} action={loginModalAction} />
            <RequestAccessModal showRequestAccessModal={showRequestAccessModal} setShowRequestAccessModal={setShowRequestAccessModal} />
            <FeatureLockedModal showFeatureLockedModal={showFeatureLockedModal} setShowFeatureLockedModal={setShowFeatureLockedModal} onLoginClick={() => { setLoginModalAction('login'); setShowLoginModal(true); }} onCreateFreeAccountClick={onCreateFreeAccountClick} />
            <CrowdStrikeDomainSettings />
        </div >
    );
};

export default DashboardNavigation;
